
/* injects from baggage-loader */
var Template = require('./template.js');
var Template = require('./../../../../skins/newbettingterminal-bet-one.betconstruct.com/terminal/components/languageSwitcher/template.js');

import { Component } from "react";
import { UIMixin } from "../../../mixins/uiMixin";
import { connect } from "react-redux";
import {PreferencesSet} from "../../../actions/index";
import { ChangeSportsbookLayout, RegisterMode } from "../../../actions/terminal";
import PropTypes from "prop-types";

class LanguageSwitcher extends Component {
    constructor (props) {
        super(props);
        this.state = {
            activeSetting: this.props.isAsian ? 1 : 0
        };
        this.setHandleClick = this.setHandleClick.bind(this);
        this.changeSportsbookLayout = this.changeSportsbookLayout.bind(this);
        this.registerPopupForDms = this.registerPopupForDms.bind(this);
    }

    setHandleClick (type) {
        let { isOpenedLanguages, isOpenedSettingSportsBook } = this.props;
        switch (type) {
            case "openLanguages":
                return () => {
                    this.props.uiClose("settingSportsbook")();
                    isOpenedLanguages ? this.props.uiClose("openLanguages")() : this.props.uiOpen("openLanguages")();
                };
            case "settingSportsbook":
                return () => {
                    this.props.uiClose("openLanguages")();
                    isOpenedSettingSportsBook ? this.props.uiClose("settingSportsbook")() : this.props.uiOpen("settingSportsbook")();
                };
            default:
                return null;
        }
    }

    changeLanguageTo (lang) {
        return () => {
            this.props.dispatch(PreferencesSet("lang", lang));
            setTimeout(() => window.location.reload(), 500);
        };
    }

    changeSportsbookLayout (type, activeSetting) {
        return () => {
            sessionStorage.setItem('asianData', JSON.stringify({asian: type === "asian"}));
            this.props.dispatch(ChangeSportsbookLayout(type === "asian"));
            window.location.reload();
            this.setState({activeSetting});
        };
    }

    registerPopupForDms () {
        return () => {
            this.props.openPopup("dmsRegister")();
            this.props.dispatch(RegisterMode(true));
        };
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

LanguageSwitcher.propTypes = {
    uiClose: PropTypes.func,
    uiOpen: PropTypes.func,
    isAsian: PropTypes.bool,
    user: PropTypes.object,
    preferences: PropTypes.object,
    isOpenedLanguages: PropTypes.any,
    isOpenedSettingSportsBook: PropTypes.any
};

const mapStateToProps = state => {
    return {
        user: state.user,
        preferences: state.preferences,
        isAsian: state.terminal.isAsian,
        isAdminLoggedIn: state.terminal.isAdminLoggedIn,
        isOpenedLanguages: state.uiState.opened["openLanguages"],
        isOpenedSettingSportsBook: state.uiState.opened["settingSportsbook"]
    };
};

export default connect(mapStateToProps)(UIMixin({Component: LanguageSwitcher}));